module.exports = __webpack_public_path__ + "static/media/excel.57327700.svg";